export const addHoursToDate = (baseDate: Date, hours: number): Date => {
  return new Date(baseDate.getTime() + hours * 60 * 60 * 1000);
};
